import {
  createColumn,
  formatAmount,
  numberFormat,
} from "../../../../utils/helpers";
import { API_AGENT_PERFORMANCE_REPORTS } from "../../../../utils/apis";

// Helper: Calculate Collection Percentage
const calculateCollectionPercentage = (
  collections: number,
  assessments: number,
) => {
  if (!assessments || assessments === 0) return "0.0%";
  return `${((collections / assessments) * 100).toFixed(1)}%`;
};

export const useAgentPerformanceReports = () => {
  const tableColumns = () => [
    createColumn("agent_name", true, "Agent Name"),
    createColumn("street_name", true, "Street Name"),
    createColumn("parking_yard", true, "Parking Yard"),
    createColumn("parking_sessions", false, "Sessions"),
    createColumn("assessments", false, "Assessments"),
    createColumn("collections", false, "Collections"),
    createColumn("collection_percentage", false, "Collection %"),
  ];

  const tableData = (data: any) => {
    if (!data) return [];

    return data.map((item: any, index: number) => {
      const collections = parseFloat(item?.collections ?? 0);
      const assessments = parseFloat(item?.assessments ?? 0);

      return {
        ...item,
        id: index, // Since the API doesn't provide an id, use index
        agent_name: item?.agent_name || "Unknown Agent",
        street_name: item?.street_name || "N/A",
        parking_yard: item?.parking_yard || "N/A",
        parking_sessions: item?.parking_sessions || 0,
        assessments: numberFormat(assessments),
        collections: numberFormat(collections),
        collection_percentage: calculateCollectionPercentage(
          collections,
          assessments,
        ),
      };
    });
  };

  const viewData = (item: any) => {
    if (!item) {
      return {
        sections: [
          {
            title: "Error",
            fields: { message: "No data available" },
          },
        ],
      };
    }

    const collections = parseFloat(item?.collections ?? 0);
    const assessments = parseFloat(item?.assessments ?? 0);
    const collectionPercentage = calculateCollectionPercentage(
      collections,
      assessments,
    );
    const shortfall = assessments - collections;

    return {
      sections: [
        {
          title: "Agent Performance Details",
          fields: {
            agent_name: item?.agent_name || "Unknown Agent",
            street_name: item?.street_name || "N/A",
            parking_yard: item?.parking_yard || "N/A",
            parking_sessions: item?.parking_sessions || 0,
            assessments: formatAmount(assessments),
            collections: formatAmount(collections),
            collection_percentage: collectionPercentage,
            shortfall: formatAmount(shortfall),
          },
        },
        {
          title: "Performance Analysis",
          fields: {
            performance_rating:
              collections / assessments >= 0.8
                ? "Excellent"
                : collections / assessments >= 0.6
                  ? "Good"
                  : collections / assessments >= 0.4
                    ? "Fair"
                    : "Needs Improvement",
            average_per_session:
              item?.parking_sessions > 0
                ? formatAmount(assessments / item.parking_sessions)
                : "N/A",
            collection_efficiency: collectionPercentage,
            sessions_productivity:
              item?.parking_sessions > 0
                ? `${(assessments / item.parking_sessions).toFixed(0)} UGX per session`
                : "N/A",
          },
        },
      ],
    };
  };

  const exportData = {
    api: API_AGENT_PERFORMANCE_REPORTS,
    fileName: `agent_performance_${new Date().toISOString().split("T")[0]}.xlsx`,
    showCustomDateRange: true,
    start_date: "start_date",
    end_date: "end_date",
  };

  // const formRoute = getForm(URL_AGENT_PERFORMANCE_REPORTS);
  const activityFilter = "agent_performance_report";

  return {
    tableData,
    tableColumns,
    viewData,
    // formRoute,
    activityFilter,
    exportData,
  };
};
